import { useCallback } from "react";
import { useAnalyticsContext, TrackingEvent, ProductType } from "@/analytics";
import { buildHotelEcommerceItem } from "@/analytics/services/hotel/utils";
import { setHotelListContext } from "@/analytics/services/hotel/hotelListContextStorage";

/**
 * Hotel select_item analytics hook
 *
 * Listeden bir otel kartına tıklandığında select_item event'ini tetikler.
 * Item verisi listedeki otel objesinden (mapHotelItem / mapLandingHotelItem) buildHotelEcommerceItem ile üretilir;
 * datalayer alanları view_item_list ile aynı (item_category2–5, hotel_country, hotel_region, state, hotel_theme, start_date, end_date, affiliation vb.).
 * basket_id bu akışta atanmadığı için gönderilmez.
 *
 * @param {Object} params
 * @param {string} params.itemListId
 * @param {string} params.itemListName
 * @param {Object} params.passengers - { guest_total, guest_adult_number, guest_children_number }
 * @param {string} [params.currency]
 * @param {string} [params.crossProductPromotion]
 */
export function useHotelSelectItemAnalytics({
  itemListId,
  itemListName,
  passengers,
  currency = "TRY",
  crossProductPromotion,
}) {
  const { dispatch: trackingDispatch } = useAnalyticsContext();

  const trackSelectItem = useCallback(
    ({ hotel, index }) => {
      if (!hotel) return;

      const items = buildHotelEcommerceItem({
        product: hotel,
        index,
        item_list_id: itemListId,
        item_list_name: itemListName,
        cross_product_promotion: crossProductPromotion,
      });

      // value: netPrice istenir (gross değil). Hotel map'i `price` alanına net'i koyar.
      const value = typeof hotel?.price === "number" ? hotel.price : undefined;

      const ecommerce = {
        item_list_id: itemListId,
        item_list_name: itemListName,
        currency,
        ...(typeof value === "number" ? { value } : {}),
        passengers,
        items,
      };

      // Detay sayfasında view_item ile senkron: tıklanan listenin adını sakla
      setHotelListContext(itemListId, itemListName);

      trackingDispatch({
        type: TrackingEvent.SELECT_ITEM,
        payload: {
          productType: ProductType.HOTEL,
          ecommerce,
        },
      });
    },
    [
      crossProductPromotion,
      currency,
      itemListId,
      itemListName,
      passengers,
      trackingDispatch,
    ],
  );

  return { trackSelectItem };
}

